
export default function stripTags(str) { 
    if (str) {
        return str.replace(/<.+?>/g, '').replace(/&nbsp;/g, ' '); 
    } else {
        return str;
    }
};
